import * as C from './../../constants/constants';

export const switchLoader = (property) => ({
    type: C.SWITCH_LOADER,
    payload: property
});
